import dayjs, { Dayjs } from 'dayjs';

export const API_TIME_DEFAULT_FORMAT = 'DD.MM.YYYY';

/** 1 => '01'; 2 => '02'*/
export const normalizeToUTCFormat = (value: number): string => {
  return String(value).padStart(2, '0');
};

/** По умолчанию, нативный Date считает даты от 0 до 11 месяца */
export const normalizeMonth = (month: number): number => month + 1;

export const normalizeDateValue = (raw: string): Dayjs => {
  return dayjs(raw, API_TIME_DEFAULT_FORMAT);
};

export const dayJsToServerFormat = (date: Dayjs): string => {
  return date.format(API_TIME_DEFAULT_FORMAT);
};

export const getDefaultDayjsValue = (): Dayjs => dayjs(new Date());
